module.exports = __webpack_public_path__ + "static/media/dancing_low_impact_workout_class.6aa34e98.webp";